import { Button, Flex, Icon, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { CreateCandidateBlock } from "../../components/CandidateBlock/CreateCandidateBlock/CreateCandidateBlock";
import { Layout } from "../../components/Layout/Layout";
import { useFormik } from "formik";
import { IUpdateCandidateBody } from "../../api/candidate/types";
import { useAppDispatch } from "../../store";
import { fetchCreateCandidate } from "../../store/slices/candidates";
import { FiUser } from "react-icons/fi";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { UserRole } from "@/api/auth/types";
import { useAppSelector } from "@/store";
import { selectUserRole } from "@/store/slices/user";

export const CreateCandidatePage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const role = useAppSelector(selectUserRole);
  const isAdmin = role === UserRole.ADMIN;

  const formik = useFormik<IUpdateCandidateBody>({
    initialValues: {
      first_name: "",
      last_name: "",
      patronymic_name: "",
      country: null,
      town: undefined,
      expected_position: "",
      expected_salary: "",
      internal_rate: "",
      contacts: "",
      contact_email: "",
      contact_phone: "",
      contact_telegram: "",
      contact_whatsapp: "",
      birthday: "",
      attachments: [],
      comments: "",
      source: null,
      grade: null,
      skills_ids: [],
      url: "",
      expected_salary_currency: "RUB",
      department_id: null,
      channel_id: null,
    },
    onSubmit: () => {},
  });

  return (
    <Layout>
      <Flex flexDirection="column" gap="24px" paddingRight="32px" maxH="90vh" overflowY="auto">
        <Flex flexDirection="column" gap="4px">
          <Text
            color="gray.500"
            cursor="pointer"
            onClick={() => navigate("/candidate")}
            display="flex"
            alignItems="center"
            gap="8px"
            marginBottom="8px"
          >
            <ArrowBackIcon />К списку кандидатов
          </Text>
          <Text fontSize={30} lineHeight="36px" fontWeight={700} color="#3b515e">
            Добавить кандидата
          </Text>
          <Text fontSize={16} lineHeight="24px" fontWeight={400} color="#65758b">
            Создание нового кандидата в базе
          </Text>
        </Flex>
        <CreateCandidateBlock formik={formik} />
        <Flex alignSelf="flex-end" gap="16px">
          <Button variant="outline" onClick={() => navigate("/candidate")}>
            Отмена
          </Button>
          <Button
            variant="solid"
            leftIcon={<Icon as={FiUser as any} boxSize={4} />}
            bg="#61a6fa"
            color="white"
            _hover={{ bg: "#61a6fa", opacity: 0.8 }}
            onClick={() => {
              dispatch(fetchCreateCandidate({ params: formik.values })).then((res: any) => {
                if (res.payload.id) {
                  navigate(`/candidate/${res.payload.id}`);
                }
              });
            }}
            isDisabled={
              formik.values.last_name === "" ||
              formik.values.first_name === "" ||
              formik.values.expected_position === "" ||
              formik.values.source === null ||
              (isAdmin && formik.values.channel_id === null)
            }
          >
            Создать кандидата
          </Button>
        </Flex>
      </Flex>
    </Layout>
  );
};
